import React, { useState } from 'react';
import './DownClickablePopup.css';

const DownClickablePopup = ({ children, popUpTitle, filters }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className="sort-popup-wrapper">
            <div onClick={() => setIsOpen(!isOpen)} className="sort-popup-trigger">
                {children}
            </div>
            {isOpen && (
                <div className="sort-popup-content">
                    <div className='headerAction'>
                        <div>
                            {popUpTitle && <span className="sort-popup-title">{popUpTitle}</span>}
                            {!popUpTitle && <span className="sort-popup-title">Action</span>}
                        </div>
                        <span className="sort-popup-close" onClick={() => setIsOpen(false)}>
                            <span className="material-icons">close</span>
                        </span>
                    </div>
                    {filters}
                </div>
            )}
        </div>
    );
};

export default DownClickablePopup;